import { EventCategory, TabEvent } from '@lendi/analytics-web';

import { lendiAnalytics } from './analytics';
import { eventTracking } from './base';

// Tab event
const TAB_CLICK = 'Tab Clicked';
export function tabEventTracking(
  analytics: ReturnType<typeof lendiAnalytics>,
  props: Pick<TabEvent, 'tabName' | 'position'>
) {
  eventTracking<TabEvent>(analytics, {
    ...props,
    event_name: TAB_CLICK,
    category: EventCategory.FUNNELS,
  });
}
